import {
  GET_TERM_RECORDS,
  GET_TERM_RECORDS_SUCCESS,
  GET_TERM_RECORDS_ERROR,
  UPDATE_TERM_RECORDS,
  REFRESH_TERM_RECORDS,
  UPDATE_SEARCH_RECORDS,

} from "../actions";

export const getTermRecords = (vocabularyId) => {
  return {
    type: GET_TERM_RECORDS,
    payload: {vocabularyId},
  };
};

export const getTermRecordsSuccess = (recordList) => ({
  type: GET_TERM_RECORDS_SUCCESS,
  payload: recordList,
});

export const getTermRecordsError = (message) => ({
  type: GET_TERM_RECORDS_ERROR,
  payload: { message },
});

export const setSelectedTerms = (newRecordList) => {
  return {
    type: UPDATE_TERM_RECORDS,
    payload: {newRecordList},
  };
};

export const setSelectedSearch = (searchText) => {
  return {
    type: UPDATE_SEARCH_RECORDS,
    payload: {searchText},
  };
};

export const refreshTerms = () => {
  return {
    type: REFRESH_TERM_RECORDS,
    payload: {},
  };
};
